import {
  isSequenceApiError,
  isSequenceApiErrorResponse,
  type SequenceError
} from '@sequencehq/api'

// `errors` is typed as a non-optional array on both the API error response and
// nested SequenceErrors, but the backend can omit it at runtime, so normalise
// to an array before mapping to avoid a crash (Sentry DASHBOARD-WEB-2G4).
const toSequenceErrors = (errors: SequenceError[]): SequenceError[] =>
  Array.isArray(errors) ? errors : []

/**
 * Extract the most user-friendly message from a SequenceError.
 * Prefers nested leaf-level messages (which omit exception prefixes)
 * over the top-level message.
 */
const getErrorMessage = (err: SequenceError): string | undefined => {
  const nestedMessages = toSequenceErrors(err.errors)
    .map(nested => nested.message)
    .filter(Boolean)
  if (nestedMessages.length > 0) {
    return nestedMessages.join('. ')
  }
  return err.message || undefined
}

export const getApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (isSequenceApiError(error) && isSequenceApiErrorResponse(error.response)) {
    const messages = toSequenceErrors(error.response.error.errors)
      .map(getErrorMessage)
      .filter(Boolean)
    if (messages.length > 0) {
      return messages.join('. ')
    }
  }
  return fallback
}
